module.exports = __webpack_public_path__ + "static/media/Y14.4822996d.mp3";